import React, { useCallback, useMemo } from "react";
import { ExclamationCircleFilled } from "src/icons";
import { safeGet } from "src/shared/utils";
import styles from "./index.module.scss";
import Shimmer from "src/shared/components/CustomisedShimmer";
import ChartFallback from "src/shared/components/ChartFallback";

type MetricCardProps = {
  bigNumber?: string;
  vCompare?: string;
  progress?: boolean;
  header: string;
  showDetails: (id: any, name: string) => void;
  id: number;
  successful: boolean;
  failure: boolean;
  isPositive: boolean;
  hasChart: boolean;
  isAnomalous: 0 | 1 | 2;
  isStaleMetric: string;
};

const MetricCard = (props: MetricCardProps) => {
  const { bigNumber, vCompare, progress, id, successful, failure, isPositive, hasChart } = props;

  const clickCard = useCallback(
    (ev: React.MouseEvent) => {
      if (ev) {
        const metricId = ev.currentTarget.getAttribute("data-item");
        props.showDetails(metricId, props.header);
      }
    },
    [props.showDetails]
  );

  const barsConfig = useMemo(
    () => [
      { height: "2rem", width: "5.52rem", repeatBar: 1 },
      {
        height: "1.4rem",
        width: "4.16rem",
        repeatBar: 1,
        style: { marginTop: "4%" },
      },
    ],
    []
  );

  return (
    <div className={styles["metric-card"]} onClick={clickCard} data-item={id}>
      <div className={styles["metric-card-header"]}>{props.header}</div>
      {hasChart && successful && (
        <>
          <div className={styles["card-chart-number"]}>
            <span>{bigNumber}</span>
            {(safeGet(props, "isAnomalous") || safeGet(props, "isStaleMetric")) && (
              <ExclamationCircleFilled className={styles["anomaly"]} />
            )}
          </div>
          <div
            className={
              vCompare === ""
                ? styles["card-chart-neutral"]
                : `${progress == isPositive ? styles["card-chart-up"] : styles["card-chart-down"]} ${
                    progress ? styles["up-arrow"] : styles["down-arrow"]
                  }`
            }
          >
            {vCompare}
          </div>
        </>
      )}
      {((!hasChart && failure) || (hasChart && !successful)) && (
        <>
          <ChartFallback />
          <div className={styles[!progress ? "card-chart-down" : "card-chart-up"]}></div>
        </>
      )}
      {!hasChart && !failure && <Shimmer barsConfig={barsConfig} className={styles["Shimmer"]} />}
    </div>
  );
};
export default MetricCard;
